import { IconClock } from "@tabler/icons-react";
import { splitNumber } from "../../features/splitNumber/splitNumber";
import { Link } from "react-router";
import { useEffect, useState } from "react";

const DiscountProduct = (props: any) => {

    const [timeLeft, setTimeLeft] = useState({
        days: 0,
        hours: 0,
        minutes: 0,
        seconds: 0
    });

    useEffect(() => {

        const timer = setInterval(() => {

            const now = new Date().getTime();
            const end = new Date(props?.product?.date_on_sale_to != null ? props?.product?.date_on_sale_to : props?.quantity_check?.date_on_sale_to).getTime();

            const diff = end - now;

            if (diff <= 0) {
                clearInterval(timer);
                setTimeLeft({ days: 0, hours: 0, minutes: 0, seconds: 0 });
                return;
            }

            const days = Math.floor(diff / (1000 * 60 * 60 * 24));
            const hours = Math.floor((diff % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60));
            const minutes = Math.floor((diff % (1000 * 60 * 60)) / (1000 * 60));
            const seconds = Math.floor((diff % (1000 * 60)) / 1000);

            setTimeLeft({ days, hours, minutes, seconds });

        }, 1000);

        return () => clearInterval(timer);

    }, [props?.product?.date_on_sale_to]);


    return (
        <Link to={`/items/detail/${props.slug}`} className="text-decoration-none">
            <div data-aos="fade-left" className="card new-product-card category-card border-0">
                <div className="card-image rounded rounded-4 p-3">
                    <div className="d-flex justify-content-center">
                        <img className="img-fluid" src={props.primary_image} alt="product" />
                    </div>
                </div>
                <div className="card-body" style={{ marginTop: '-25px' }}>
                    <span className="text-dark fw-bold text-line font-medium-lg mb-0">
                        {props.name}
                    </span>

                    <p className="card-title price mb-0 fw-bold font-medium-lg mt-2">

                        {props?.has_variation !== 0 ? (
                            props.quantity_check?.price ?
                                <p className="fw-bold text-center mb-0">
                                    {splitNumber(props.sale_price != null ? props.sale_price : props.quantity_check.sale_price)} تومان
                                </p>
                                :
                                <span className="text-danger fw-bold">
                                    نا موجود
                                </span>
                        ) : (

                            <div className="d-flex justify-content-between align-items-center">
                                <p className="badge bg-danger mb-0">
                                    %{props.percent_sale != null ? props.percent_sale : props.quantity_check.percent_sale}
                                </p>
                                <div>
                                    <span className="fw-bold">
                                        {splitNumber(props.sale_price != null ? props.sale_price : props.quantity_check.sale_price)} تومان
                                    </span>

                                    <del className="text-muted d-block">
                                        {splitNumber(props.price != null ? props.price : props.quantity_check.price)}
                                    </del>
                                </div>

                            </div>

                        )}
                    </p>
                    <hr />
                    <div className="d-flex justify-content-between align-items-center mt-3">

                        <span className="font-medium text-muted">
                            <IconClock size={12} className="align-middle me-1" />
                            زمان
                        </span>

                        <span className="font-medium-lg ltr">
                            {timeLeft.days * 24} :
                            {timeLeft.minutes} :
                            {timeLeft.seconds}
                        </span>

                    </div>

                </div>

            </div>
        </Link>
    )
}

export default DiscountProduct;
